"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAnimationValue = void 0;
const serializeNumber_1 = require("./serializeNumber");
const shortest_1 = require("./shortest");
const serializeAnimationValue = (key, value) => {
    if (value === 'unset') {
        return '';
    }
    if (typeof value === 'object') {
        const timingFunction = value;
        if (timingFunction.type === 'cubic-bezier') {
            return `cubic-bezier(${timingFunction.value.map(serializeNumber_1.serializeNumber).join(',')})`;
        }
        return `steps(${timingFunction.stepCount},${timingFunction.direction})`;
    }
    if (typeof value === 'number') {
        switch (key) {
            case 'duration':
            case 'delay':
                return (0, shortest_1.shortest)(`${(0, serializeNumber_1.serializeNumber)(value)}ms`, `${(0, serializeNumber_1.serializeNumber)(value * 0.001)}s`);
            default:
                return (0, serializeNumber_1.serializeNumber)(value);
        }
    }
    return `${value}`;
};
exports.serializeAnimationValue = serializeAnimationValue;
